import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { Violation } from './validation.types'

export function useLengthCheck(text: string, maxChars: number) {
  const { t } = useTranslation()
  return useMemo(() => {
    const charsUsed = (text ?? '').length
    const isOver = maxChars > 0 && charsUsed > maxChars
    const violation: Violation | null = isOver
      ? { type: 'length', severity: 'error', message: t('remake.validation.overLimit', { used: charsUsed, max: maxChars }) }
      : null
    return { charsUsed, maxChars, isOver, violation }
  }, [text, maxChars, t])
}
